module.exports = __webpack_public_path__ + "img/logo-footer.4f92308b.png";